import graphql__fe2df30398eb3deeb11a from "./__generated__/SetDefaultPaymentMethodDialog_customerAccount.graphql.ts";
import graphql__c94243ae04eab04a5557 from "./__generated__/SetDefaultPaymentMethodDialog_paymentMethod.graphql.ts";
import graphql__4336ad8d1b25a3b332fe from "./__generated__/SetDefaultPaymentMethodDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type SetDefaultPaymentMethodDialogProps = {
    customerAccount: any,
    paymentMethod: any,
    handleCloseDialog: () => {}
}

const SetDefaultPaymentMethodDialog: React.FC<SetDefaultPaymentMethodDialogProps> = (props) => {

    const intl = useIntl();
    const customerAccount = useFragment(
        graphql__fe2df30398eb3deeb11a,
        props.customerAccount
    );

    const paymentMethod = useFragment(
        graphql__c94243ae04eab04a5557,
        props.paymentMethod
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__4336ad8d1b25a3b332fe,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSetDefaultPaymentMethod'})
            }
        )
    }

    const initialValues = {
        customerAccountIdentifier: customerAccount.id,
        paymentMethodIdentifier: paymentMethod.id
    }

    let paymentMethodType;
    switch (paymentMethod.paymentMethodType) {
        case 'Card': {
            switch (paymentMethod.cardBrand) {
                case 'visa':
                    paymentMethodType = intl.formatMessage({id: 'paymentMethod.Card.visa'});
                    break;
                case 'mastercard':
                    paymentMethodType = intl.formatMessage({id: 'paymentMethod.Card.mastercard'});
                    break;
                default:
                    paymentMethodType = intl.formatMessage({id: 'paymentMethod.Card'});
                    break;
            }
            break;
        }
        case 'SepaDebit': {
            paymentMethodType = intl.formatMessage({id: 'paymentMethod.SepaDebit'});
            break;
        }
        default: {
            paymentMethodType = intl.formatMessage({id: 'paymentMethod.unknown'});
        }
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.SetDefaultPaymentMethodDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.SetDefaultPaymentMethodDialog.submitLabel'})}>
            <Section>
                <Row>
                    <div className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.SetDefaultPaymentMethodDialog.confirmMessage'}, {
                            paymentMethodType: paymentMethodType,
                            lastFourDigits: paymentMethod.lastFourDigits,
                            customer: customerAccount.customerName
                        })}
                    </div>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default SetDefaultPaymentMethodDialog;
